/* eslint-disable react/prop-types */
import React from 'react'
import {
  ProductItemContainer, ProductItem, ProductImageContainer, ProductImage, ProductInfoContainer, ProductDescription,
} from './ProductItem/styled'
import { ProductCategoryTabs, EmptyTab } from './styled'
import LazyImage from '../../../components/LazyImage'

function PlaceholderList({ headerHeight }) {
  const List = [...Array(5).keys()]
  return (
    <div>
      <ProductCategoryTabs headerHeight={headerHeight}>
        {List.map(index => (
          <EmptyTab key={index} active={index === 0}>
            <LazyImage size={10} src="" />
          </EmptyTab>
        ))}
      </ProductCategoryTabs>
      {List.map(index => (
        <ProductItemContainer key={index}>
          <ProductItem>
            <ProductImageContainer>
              <ProductImage size={90} src="" />
            </ProductImageContainer>
            <ProductInfoContainer>
              <ProductDescription>
                <LazyImage size={10} src="" />
              </ProductDescription>
            </ProductInfoContainer>
          </ProductItem>
        </ProductItemContainer>
      ))}
    </div>
  )
}

export default PlaceholderList
